<select class="form-select appearance-none pr-8 pl-2 py-2 bg-no-repeat rounded shadow" [ngClass]="getClass()" *transloco="let t" (change)="onChanged($event)" [attr.aria-label]="t(multiOption.translationPrefix)">
   @for(option of options;track option) {
      <option class="text-neutral-600 leading-tight" [selected]="isSelected(option)" [value]="option.value">{{ t( multiOption.translationPrefix + '.' + option.value) }}</option>
   }
</select>
